import { Grid2, Stack, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { colors } from "../../values/colors";
import moment from "moment";
import { maskStringAtEnd, maskStringAtStart } from "../../uttils/common";

export const OverView = ({ item }) => {
  const [tournamentDetailsArray, setTournamentDetailsArray] = useState([]);

  useEffect(() => {
    const tempTournamentDetailsArray = [
      {
        name: "Tournament Dates",
        value: `${moment(item?.startDate).format("DD MMM, YYYY")} - ${moment(
          item?.endDate
        ).format("DD MMM, YYYY")}`,
      },
      {
        name: "Tournament Category",
        value: item?.tournament_cat,
      },
      {
        name: "Tournament Type",
        value: item?.tournamentType,
      },

      {
        name: "Number of Teams",
        value: item?.teamCount,
      },
      {
        name: "Number of Players",
        value: item?.teamPlayerCount,
      },
      {
        name: "Ball Type",
        value: item?.ballType,
      },
      // {
      //   name: "Pitch Type",
      //   value: `${moment(item?.startDate).format("DD MMM, YYYY")} - ${moment(
      //     item?.endDate
      //   ).format("DD MMM, YYYY")}`,
      // },
      {
        name: "Match Type",
        value: item?.matchType,
      },
    ];

    setTournamentDetailsArray(tempTournamentDetailsArray);
  }, []);
  const TournamentDetailsCard = (ele) => {
    console.log(ele, "details");

    return (
      <Stack
        spacing={0.5}
        mr={2}
        my={2}
        p={2}
        sx={{
          boxShadow: "0px 3px 5px rgba(0, 0, 0, 0.2)",
          borderRadius: "6px",
        }}
      >
        <Typography variant="subtitle3">{ele?.ele?.name}</Typography>
        <Typography variant="subtitle1" sx={{ fontSize: "1.2rem" }}>
          {ele?.ele?.value}
        </Typography>
      </Stack>
    );
  };

  const OrganizerDetailsCard = () => {
    return (
      <Stack
        spacing={0.5}
        my={2}
        p={2}
        sx={{
          boxShadow: "0px 5px 5px rgba(0, 0, 0, 0.2)",
          borderRadius: "6px",
        }}
      >
        <Typography variant="subtitle3">{"Organizer Details"}</Typography>
        <Typography variant="subtitle1" sx={{ fontSize: "1.2rem" }}>
          {item?.organizerId?.name}
        </Typography>
        <Typography variant="subtitle3" sx={{ fontWeight: 500 }}>
          {maskStringAtStart(item?.organizerId?.phone, -4, "*")}
        </Typography>
        <Typography variant="subtitle3" sx={{ fontWeight: 500 }}>
          {maskStringAtEnd(item?.organizerId?.email?.split("@")[0], 4, "*") +
            item?.organizerId?.email?.split("@")[1]}
        </Typography>
      </Stack>
    );
  };

  const TournamentDescriptionCard = (ele) => {
    return (
      <Stack
        spacing={0.5}
        my={2}
        p={2}
        sx={{
          boxShadow: "0px 5px 5px rgba(0, 0, 0, 0.2)",
          borderRadius: "6px",
        }}
      >
        <Typography variant="h5" sx={{ color: colors.black }}>
          {item?.description}
        </Typography>
      </Stack>
    );
  };

  return (
    <Stack spacing={2} p={2}>
      <Stack>
        <Typography variant="subtitle1" sx={{ fontSize: "1.3rem" }}>
          {"Tournament Details"}
        </Typography>
        <Grid2 container size={12}>
          {tournamentDetailsArray?.map((ele) => (
            <Grid2 size={{ xs: 12, sm: 12, md: 4 }}>
              <TournamentDetailsCard ele={ele} />
            </Grid2>
          ))}
        </Grid2>
      </Stack>
      <Stack>
        <Typography variant="subtitle1" sx={{ fontSize: "1.3rem" }}>
          {"Organizer Details"}
        </Typography>
        <Grid2 container size={12}>
          <Grid2 size={{ xs: 12, sm: 12, md: 4 }}>
            <OrganizerDetailsCard />
          </Grid2>
        </Grid2>
      </Stack>

      {item?.description && (
        <Stack>
          <Typography variant="subtitle1" sx={{ fontSize: "1.3rem" }}>
            {"Tournament Description"}
          </Typography>
          <Grid2 container size={12}>
            <Grid2 size={{ xs: 12, sm: 12, md: 8 }}>
              <TournamentDescriptionCard />
            </Grid2>
          </Grid2>
        </Stack>
      )}
    </Stack>
  );
};
